module.exports = __webpack_public_path__ + "img/hero-our-plan.2a738f88.jpg";